<!-- 等级用户-编辑页 -->
<template>
  <div id="edit" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">
      {{ $route.query.ifEdit ? '编辑' : '新建'
      }}{{ ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][$route.query.ifEdit ? Number($route.query.tier) : Number($route.query.tier) + 1] || '一' }}级用户
    </div>
    <!-- 编辑表单 -->
    <div class="edit_form">
      <el-form :model="accountItem" :rules="rules" label-position="top" ref="accountItem" label-width="100px" class="form_salesContract">
        <el-row :gutter="20">
          <!-- 用户名称 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="用户名称" prop="enterprieName">
              <el-input v-model="accountItem.enterprieName" placeholder="请输入用户名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 所属上级用户 -->
          <el-col v-if="$route.query.tier && $route.query.tierId" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="所属上级用户">
              <el-input v-model="accountItem.tierName" placeholder="请输入用户名称" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 用户名称 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="用户名/邮箱" prop="registerMail">
              <el-input v-model="accountItem.registerMail" placeholder="请输入用户名/邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="!$route.query.id" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <!-- 账号密码 -->
            <el-form-item label="账号密码" prop="password">
              <el-input v-model="accountItem.password" placeholder="请输入账号密码" clearable disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 目前所涉及的行业 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="目前所涉及的行业" required>
              <el-cascader
                class="cascader"
                ref="tradeList"
                v-model="selected_trade"
                :options="tradeList"
                :props="props_cascader"
                clearable
                @change="handleChange"
                placeholder="请选择目前所涉及的行业"
                size="small"
                style="width: 100%"></el-cascader>
            </el-form-item>
          </el-col>
          <!-- 企业邮箱 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业邮箱" prop="enterprieMail">
              <el-input v-model="accountItem.enterprieMail" placeholder="请输入企业邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业电话 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业电话" prop="enterpriePhone">
              <el-input v-model="accountItem.enterpriePhone" placeholder="请输入企业电话" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业Logo -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业Logo" required>
              <el-input v-model="files_logo[0].name" placeholder="请上传企业Logo" disabled>
                <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_logo">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 统一社会信用代码 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model="accountItem.code" placeholder="请输入统一社会信用代码" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业地址 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业地址">
              <el-input v-model="accountItem.address" placeholder="请输入企业地址" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业法人 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业法人">
              <el-input v-model="accountItem.enterpriseLegalPerson" placeholder="请输入企业法人" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 法人联系方式 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="法人联系方式">
              <el-input v-model="accountItem.enterpriseLegalPersonPhone" placeholder="请输入法人联系方式" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 企业联系人 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="企业联系人">
              <el-input v-model="accountItem.enterprieContacts" placeholder="请输入企业联系人" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 联系人电话 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="联系人电话">
              <el-input v-model="accountItem.contactsPhone" placeholder="请输入联系人电话" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 联系人邮箱 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="联系人邮箱">
              <el-input v-model="accountItem.contactsMail" placeholder="请输入联系人邮箱" clearable></el-input>
            </el-form-item>
          </el-col>

          <!-- 营业执照 -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="营业执照">
              <el-input v-model="files_businessLicense[0].name" placeholder="请上传营业执照" disabled>
                <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_businessLicense">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="common.isLogin() == -1" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="生成自评报告次数">
              <el-input @input="handleInput" v-model="accountItem.selfNumber" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="common.isLogin() == -1" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="生成报告次数">
              <el-input @input="handleInputtwo" v-model="accountItem.expertNumber" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表单按钮 -->
    <div class="absoluteGrop">
      <el-button type="primary" @click="submitForm('accountItem')">保存</el-button>
      <el-button plain @click="$router.push('/accountPages/orgManage')">返回</el-button>
    </div>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>
  </div>
</template>
<script>
import cropper from '../../../components/cropper.vue';
export default {
  name: 'edit',
  components: { cropper },
  data() {
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的密码'));
      } else {
        const reg = /^(\w){6,20}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('密码由6-20个字母、数字、下划线组成，请重新输入'));
        }
      }
    };
    let checkEmai = (rule, value, callback) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!value) {
        callback(new Error('请输入企业邮箱'));
      } else if (!emailRegex.test(value)) {
        callback(new Error('请输入正确的邮箱格式'));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的手机号'));
      } else {
        const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      accountItem: { password: '123456' },
      tradeList: [],
      props_cascader: {
        expandTrigger: 'hover',
        multiple: true,
        label: 'name',
        value: 'id',
        children: 'industryCategoryList',
      },
      selected_trade: [],
      rules: {
        enterprieName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        registerMail: [{ required: true, message: '请输入用户名/邮箱', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'blur' },
          { validator: checkPwd, trigger: 'blur' },
        ],
        enterprieMail: [
          { required: true, message: '请输入企业邮箱', trigger: 'blur' },
          { validator: checkEmai, trigger: 'change' },
        ],
        enterpriePhone: [
          { required: true, message: '请输入企业电话', trigger: 'blur' },
          { validator: checkPhone, trigger: 'change' },
        ],
        logo: [{ required: true, message: '请上传企业logo', trigger: 'blur' }],
      },
      // 附件
      files_logo: [{ name: '' }],
      files_businessLicense: [{ name: '' }],
    };
  },
  created() {
    this.getIndustryTypes();
    if (this.$route.query.ifEdit) {
      //编辑跳转
      this.getInfo();
    } else if (this.$route.query.tier) {
      //新增子级
      this.$set(this.accountItem, 'tierName', this.$route.query.tierName);
      this.$set(this.accountItem, 'tier', Number(this.$route.query.tier) + 1);
      this.$set(this.accountItem, 'parentId', this.$route.query.tierId);
    } else {
      this.$set(this.accountItem, 'tier', 1);
    }
  },
  mounted() {},
  methods: {
    handleInput(value) {
      const formattedValue = value.replace(/[^0-9]/g, ''); // 去掉所有非数字字符
      this.accountItem.selfNumber = formattedValue; // 更新 v-model 绑定的数据
    },
    handleInputtwo(value) {
      const formattedValue = value.replace(/[^0-9]/g, ''); // 去掉所有非数字字符
      this.accountItem.expertNumber = formattedValue; // 更新 v-model 绑定的数据
    },
    //获取目前所涉及的行业
    getIndustryTypes() {
      this.$axios
        .post(`${process.env.BASE_URL}api/industry/industryList`, { keyWords: '', page: 1, limit: 999999, isUse: 1 })
        .then((res) => {
          if (res.data.code === 200) {
            this.tradeList = Object.assign([], res.data.page.list);
          } else {
            this.$message({
              type: 'error',
              message: '查询失败-' + res.data.msg,
              offset: 80,
            });
          }
        })
        .catch((err) => {});
    },
    //获取信息
    getInfo() {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/userInfo`, { id: this.$route.query.id })
        .then((res) => {
          if (res.data.code == 200) {
            this.accountItem = JSON.parse(JSON.stringify(res.data.data));
            // Object.keys(res.data.data).forEach((key) => {
            //   if (key != 'logo' && key != 'businessLicense' && res.data.data[key]) {
            //     this.$set(this.accountItem, key, res.data.data[key]);
            //   }
            // })
            // 状态回显赋值
            if (this.accountItem.selfNumber == null) {
              this.accountItem.selfNumber = '无限制';
            }
            if (this.accountItem.expertNumber == null) {
              this.accountItem.expertNumber = '无限制';
            }
            this.selected_trade = [];
            if (this.accountItem.industryCategory) {
              if (this.accountItem.industryCategory.indexOf(',') > -1) {
                let industryArr = this.accountItem.industryCategory.split(',');
                industryArr.forEach((item) => {
                  this.selected_trade.push(item.split('-'));
                });
              } else {
                this.selected_trade.push(this.accountItem.industryCategory.split('-'));
              }
            }
            // 附件回显赋值
            this.setFiles_init();
          } else {
            console.log(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChange(val) {
      this.selected_trade = val;
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.selected_trade.length) {
            this.$message.error('请选择目前所涉及的行业');
          } else
          //  if (!this.files_logo[0].url) {
          //   this.$message.error('请上传企业Logo');
          // } else 
          if (!this.selected_trade.length) {
            this.$message.error('请选择目前所涉及的行业');
          } else {
            let kes_files = ['logo', 'businessLicense'];
            kes_files.forEach((key, i) => {
              let params = [];
              this['files_' + key].forEach((e) => {
                let file = { name: e.name, url: e.url };
                params.push(file);
              });
              this.$set(this.accountItem, kes_files[i], JSON.stringify(params));
            });
            // 放置目前所涉及的行业数组
            let industryArr = [];
            this.selected_trade.forEach((arrItem) => {
              industryArr.push(arrItem.join('-'));
            });
            this.$set(this.accountItem, 'industryCategory', industryArr.join(','));
            // 新增用户-放置初始密码
            if (!this.$route.query.id) {
              this.accountItem.password = '123456';
            }
            let url = `${process.env.BASE_URL}api/user/registerOther`;
            if (this.accountItem.tier == 1) {
              url = `${process.env.BASE_URL}api/user/register`;
            }
            if (this.accountItem.selfNumber == '无限制' || !this.accountItem.selfNumber) {
              this.accountItem.selfNumber = null;
            } else {
              this.accountItem.selfNumber = Number(this.accountItem.selfNumber);
            }
            if (this.accountItem.expertNumber == '无限制' || !this.accountItem.expertNumber) {
              this.accountItem.expertNumber = null;
            } else {
              this.accountItem.expertNumber = Number(this.accountItem.expertNumber);
            }

            this.$axios
              .post(url, this.accountItem)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$router.push('/accountPages/orgManage');
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },
    // 附件回显赋值
    setFiles_init() {
      let fileKeys = ['logo', 'businessLicense'];
      fileKeys.forEach((key, i) => {
        if (this.accountItem[key]) {
          let files = JSON.parse(this.accountItem[key]);
          if (files.length) {
            this['files_' + fileKeys[i]] = JSON.parse(this.accountItem[key]);
          }
        }
      });
    },
    uploadImg_logo(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'logo');
    },
    uploadImg_businessLicense(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'businessLicense');
    },
    // 图标上传回调
    callBack(data) {
      this.$message({ message: `上传成功`, type: 'success' });
      if (data.type == 'logo') {
        this.files_logo = [{ name: data.name, url: data.url }];
        this.$set(this.accountItem, 'logo', data.name);
      } else {
        this.files_businessLicense = [{ name: data.name, url: data.url }];
        this.$set(this.accountItem, 'businessLicense', data.name);
      }
    },
  },
};
</script>
<style lang="less" scoped>
// pc端
.edit_form {
  // margin-bottom: 80px;

  /deep/.el-input,
  /deep/.el-textarea {
    max-width: 500px;
  }

  /deep/.el-select,
  /deep/.el-date-editor {
    width: 300px;
  }
}

.pop_input /deep/.el-input__inner {
  font-size: 14px;
  padding: 0px 5px;
  height: 25px;
}

/deep/.el-popover {
  padding: 20px;
}
.list {
  display: flex;
  flex-direction: column;

  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;

    .el-icon-close {
      font-size: 18px;
      cursor: pointer;
    }

    .col {
      // display: flex;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .proAdd {
    justify-content: center;
    line-height: 18px;
    cursor: pointer;
  }

  .develirymed {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 15px 0;

    p {
      line-height: 15px;
    }
  }
}
/* 移动端样式 */
@media only screen and (max-width: 700px) {
  .edit_form {
    /deep/.el-select,
    /deep/.el-date-editor {
      width: 70%;
    }
  }

  .flexStart {
    /deep/.el-select {
      width: 70%;
    }
  }
}
</style>
